<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-contributi-fondo-perduto page-operative-data-analysis-contributi-fondo-perduto-edit">
    <div class="container">
      <PageTitle>Modifica contributo a fondo perduto</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Contributo a fondo perduto da modificare non trovato</div>
      <FormContributoFondoPerduto v-else-if="company && userCanEdit" :contributoFondoPerduto.sync="contributoFondoPerduto" edit @saved="saveContributoFondoPerduto" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage.js';

export default {
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle.vue'),
    FormContributoFondoPerduto: () => import('@/views/components/Operative/Form/FormContributoFondoPerduto.vue'),
  },
  data () {
    return {
      contributoFondoPerduto: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveContributoFondoPerduto (contributoFondoPerduto) {
      this.$api.updateContributoFondoPerduto(this.company.id, contributoFondoPerduto.id, contributoFondoPerduto)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.contributi-fondo-perduto',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getContributoFondoPerduto(this.company.id, this.$route.params.contributoFondoPerdutoId)
          .then(res => {
            this.contributoFondoPerduto = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
